import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { Grid } from '@mui/material'
import TextField from './TextField'
import Select from './Select'
import { optionPrefix } from '../constant'
import DateSelect from './DateSelect'
import { Column } from 'src/components/Layout/Styled'
import Consent from './Consent'
import TitleInput from './TitleInput'

const InformationItem = ({ index }) => {
  const { editable } = useSelector(
    (state) => ({
      editable: state.eLearningEnroll.body.enroll[index].editable,
    }),
    shallowEqual
  )
  return (
    <Column sx={{ rowGap: 3 }}>
      <Grid container spacing={3}>
        <TitleInput
          index={index}
          obj="prefixTH"
          isDisabled={!editable.isEditPrefixTH}
          md={4}
        />
        <TextField
          index={index}
          obj="firstNameTH"
          label="ชื่อ"
          isDisabled={!editable.isEditName}
          md={4}
          sm={6}
        />
        <TextField
          index={index}
          obj="lastNameTH"
          label="นามสกุล"
          isDisabled={!editable.isEditSurname}
          sm={4}
        />
      </Grid>
      <Grid container spacing={3}>
        <Select
          index={index}
          obj="prefix"
          label="Title Name"
          options={optionPrefix}
          isDisabled={!editable.isEditPrefix}
          md={4}
          sm={12}
        />
        <TextField
          index={index}
          obj="firstName"
          label="First Name"
          isDisabled={!editable.isEditNameEN}
          md={4}
          sm={6}
        />
        <TextField
          index={index}
          obj="lastName"
          label="Last Name"
          isDisabled={!editable.isEditSurnameEN}
          sm={4}
        />
      </Grid>
      <Grid container spacing={3}>
        <TextField
          index={index}
          obj="idCardNo"
          label="บัตรประชาชน"
          isDisabled={!editable.isEditIdCardNo}
          md={4}
          sm={12}
        />
        <DateSelect
          index={index}
          obj="birthDate"
          label="วัน เดือน ปี เกิด"
          disabled={!editable.isEditBirthDate}
          md={4}
          sm={6}
        />
        <TextField
          index={index}
          obj="mobileNo"
          label="หมายเลขโทรศัพท์มือถือ"
          isDisabled={!editable.isEditMobile}
          md={4}
        />
      </Grid>
      <Grid container spacing={3}>
        <TextField
          index={index}
          obj="email"
          label="อีเมล"
          isDisabled={true}
          md={4}
        />
      </Grid>
      <Grid container>
        <Consent />
      </Grid>
    </Column>
  )
}

export default InformationItem
